import React from 'react'
import PropTypes from 'prop-types'
import CustomerContact from './CustomerContact'
import ProcessInstanceList from './ProcessInstanceList'
import AppointmentList from '../../../appointment/component/list/AppointmentList'
import Authorization from '../../../security/component/auth/AuthorizationContainer'
import {ROLE_EMPLOYEE} from '../../../security/state/auth/const'
import TreatmentQuotationContainer from '../../../treatment/component/quotation/TreatmentQuotationContainer'
import SalesOrderList from '../../../sales-order/component/list/SalesOrderList'
import ShipmentList from '../../../logistic/component/list/ShipmentListContainer'
import {TAB_BASIC_DATA} from '../../state/detail/const'
import ImplantTreatmentQuotationWidgetContainer
    from '../../../treatment/component/task-widget/ImplantTreatmentQuotationWidgetContainer'
import {PRODUCT_TYPE_ALIGNERS, PRODUCT_TYPE_IMPLANTS} from '../../../treatment/state/quotation/const'
import SalesNotes from "../../../sales/component/SalesNotes";
import {PricesProvider} from "../../../sales/PricesContext";
import {connect} from "react-redux";

const mapStateToProps = (state, props) => {
    return {
        state,
        props
    }
}

const TabBasicData = ({state, props}) => {
    const {tab, customer, findProcessComment} = props
    if (tab !== TAB_BASIC_DATA) {
        return null
    }

    return (
        <React.Fragment>

            <Authorization requiredRole={ROLE_EMPLOYEE}>
                <ProcessInstanceList
                    findProcessComment={findProcessComment}
                    processInstanceList={customer.processList}
                />

                <AppointmentList
                    appointmentList={customer.appointmentList}
                />

            </Authorization>

            {'treatmentQuotationList' in customer && customer.treatmentQuotationList[0] && customer.treatmentQuotationList[0].type === PRODUCT_TYPE_IMPLANTS && (
                <ImplantTreatmentQuotationWidgetContainer onlyDisplay={true} validationMessageList={[]}/>
            )}

            {'treatmentQuotationList' in customer && customer.treatmentQuotationList[0] && customer.treatmentQuotationList[0].type === PRODUCT_TYPE_ALIGNERS && (
                <TreatmentQuotationContainer onlyDisplay={true} validationMessageList={[]}/>
            )}

            <CustomerContact {...props}/>

            <PricesProvider countryCode={customer.countryCode}>
                <SalesNotes customerId={customer.id} state={state}/>
            </PricesProvider>

            <Authorization requiredRole={ROLE_EMPLOYEE}>

                <ShipmentList shipmentList={customer.shipmentList}/>

                <SalesOrderList salesOrderList={customer.salesOrderList}/>

            </Authorization>
        </React.Fragment>


    )
}

TabBasicData.propTypes = {
    tab: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
    findProcessComment: PropTypes.func.isRequired,
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(TabBasicData)



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TabBasicData.js